import { esc, richText } from "./html.js";
import { fmtRub } from "../lib/money.js";
import { defaultServiceCount, serviceMaxCount, priceLabel, formulaLabel } from "../lib/services.js";

// Блок «Дополнительные услуги» (T11) внутри формы оформления. Выбор и количество живут в DOM
// (чекбокс svc-<id>, скрытое поле svc-<id>-count), цена и потолок — в data-атрибутах строки;
// index.js пересчитывает суммы точечно (recalcServices), форма не перерисовывается.
export function servicesBlock(checkout, nights) {
  if (checkout.servicesError) {
    return `
  <div class="okb-cocard okb-services">
    <h3>Дополнительные услуги</h3>
    <div class="okb-conotice">Дополнительные услуги сейчас недоступны — их можно добавить через менеджера после бронирования.</div>
  </div>`;
  }
  const list = checkout.services ?? [];
  if (!list.length) return "";
  return `
  <div class="okb-cocard okb-services">
    <h3>Дополнительные услуги</h3>
    <p class="okb-cohint">Оплачиваются при заселении, в предоплату не входят.</p>
    <ul class="okb-svclist">${list.map((s) => serviceRow(s, nights)).join("")}</ul>
  </div>`;
}

function serviceRow(s, nights) {
  const count = defaultServiceCount(s, nights);
  const max = serviceMaxCount(s, nights);
  const qty = s.chooseQuantity
    ? `
      <div class="okb-svcqty" hidden>
        <span class="okb-stepper" role="group" aria-label="Количество — ${esc(s.name)}">
          <button type="button" data-okb="svc-minus" aria-label="Меньше" ${count <= 1 ? "disabled" : ""}>−</button>
          <b data-okb-svc-count aria-live="polite">${count}</b>
          <button type="button" data-okb="svc-plus" aria-label="Больше" ${count >= max ? "disabled" : ""}>+</button>
        </span>
        <input type="hidden" name="svc-${s.id}-count" value="${count}">
        <span class="okb-svcsum"><span data-okb-svc-formula>${esc(formulaLabel(s.price, count, s.perDay))}</span> = <b data-okb-svc-line>${fmtRub(s.price * count)}</b></span>
      </div>`
    : "";
  return `
    <li class="okb-svc" data-okb-svc="${s.id}" data-okb-svc-price="${s.price}" data-okb-svc-max="${max}"${s.perDay ? ' data-okb-svc-perday="1"' : ""}>
      <label class="okb-svcmain">
        <input type="checkbox" name="svc-${s.id}" value="1"${s.description ? ` aria-describedby="okb-svc-desc-${s.id}"` : ""}>
        <span class="okb-svcbody"><span class="okb-svcname">${esc(s.name)}</span><span class="okb-svcprice">${esc(priceLabel(s))}</span></span>
      </label>
      ${s.description ? `<div class="okb-svcdesc" id="okb-svc-desc-${s.id}">${richText(s.description)}</div>` : ""}
      ${qty}
    </li>`;
}
